import { render, staticRenderFns } from "./TabelaRelacionamentosPj.vue?vue&type=template&id=c1d3e9c6&lang=pug"
import script from "./TabelaRelacionamentosPj.vue?vue&type=script&lang=js"
export * from "./TabelaRelacionamentosPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaRelacionamentosPj.vue?vue&type=style&index=0&id=c1d3e9c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports